export { default } from "./src/variant-container";
